(function () {
  if (
    window.location.pathname.indexOf('/apps/wishlist') === -1 &&
    window.location.pathname.indexOf('/pages/wishlist') === -1
  ) return;

  var currentScript = document.currentScript;
  var headingText = currentScript && currentScript.dataset.title ? currentScript.dataset.title : 'Favourite';
  var heartIconUrl = currentScript && currentScript.dataset.heartIcon ? currentScript.dataset.heartIcon : '';
  var headingSelector = '[data-nobo-wishlist-heading]';
  var countSelector = '[data-nobo-wishlist-count]';
  var removeButtonSelector = 'button, a, [role="button"]';
  var cartControlSelector = '.wk-form, form, button, a, [role="button"], input[type="submit"], [type="submit"], *';
  var cardSelector = '.wk-product-card, .wk-product, .wk-item, [class*="product-card"], [class*="product"], article, li';
  var cardBoundarySelector = 'wishlist-page, .wk-page, .wk-grid, .wk-products';
  var mediaHostSelector = [
    '.wk-product-image',
    '.wk-product-image-wrapper',
    '.wk-product-card__image',
    '.wk-product-card__image-wrapper',
    '.wk-image',
    '.wk-image-wrapper',
    '.wk-media',
    '.wk-product-media',
    '.wk-product-card-media',
    '[class*="image"]',
    '[class*="media"]'
  ].join(',');
  var syncScheduled = false;

  function isVisible(element) {
    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function getWishlistRoot() {
    return document.querySelector('wishlist-page') || document.querySelector('.wk-page');
  }

  function getHeadingHost(root) {
    var grid = root.querySelector('.wk-grid, .wk-products');
    return grid && grid.parentElement ? grid.parentElement : root.querySelector('.wk-page') || root;
  }

  function hideOriginalTitle(root) {
    Array.prototype.forEach.call(root.querySelectorAll('h1, h2'), function (heading) {
      if (heading.matches(headingSelector)) return;

      var text = heading.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === 'wishlist' || text === 'your wishlist') {
        heading.classList.add('nobo-swish-original-title');
        heading.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function getWishlistCount(root) {
    var forms = Array.prototype.filter.call(root.querySelectorAll('.wk-form'), isVisible);

    if (forms.length) {
      var cards = new Set();
      forms.forEach(function (form) {
        cards.add(form.closest('.wk-product-card, .wk-product, .wk-item, article, li') || form);
      });
      return cards.size;
    }

    var selectors = [
      '.wk-product-card',
      '.wk-product',
      '.wk-item',
      '[data-product-id]',
      '[data-wk-product-id]',
      '.wk-grid > *',
      '.wk-products > *'
    ].join(',');

    return Array.prototype.filter.call(root.querySelectorAll(selectors), function (item) {
      return !item.matches(headingSelector) && isVisible(item);
    }).length;
  }

  function ensureHeading(root) {
    var host = getHeadingHost(root);
    var heading = host.querySelector(headingSelector);

    if (!heading) {
      var grid = host.querySelector('.wk-grid, .wk-products');

      heading = document.createElement('h1');
      heading.className = 'nobo-wishlist-heading';
      heading.setAttribute('data-nobo-wishlist-heading', '');
      heading.innerHTML = '<span></span> <span data-nobo-wishlist-count></span>';
      host.insertBefore(heading, grid || host.firstElementChild);
    }

    var label = heading.querySelector('span');
    var count = heading.querySelector(countSelector);
    var countText = '(' + getWishlistCount(root) + ')';

    if (label.textContent !== headingText) {
      label.textContent = headingText;
    }

    if (count.textContent !== countText) {
      count.textContent = countText;
    }
  }

  function syncWishlistHeading() {
    var root = getWishlistRoot();
    if (!root) return;

    hideOriginalTitle(root);
    ensureHeading(root);
  }

  function getControlText(control) {
    return control.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getControlHints(control) {
    return [
      control.getAttribute('aria-label'),
      control.getAttribute('title'),
      control.getAttribute('class'),
      control.getAttribute('data-action'),
      control.getAttribute('name')
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  function isWishlistRemoveControl(control) {
    if (!heartIconUrl) return false;
    if (control.getAttribute('data-nobo-wishlist-remove-decorated') === 'true') return false;
    if (control.closest(headingSelector)) return false;
    if (isAddToCartControl(control)) return false;

    var text = getControlText(control);
    var hints = getControlHints(control);

    if (text === 'x' || text === '×') return true;
    if (hints.indexOf('remove') !== -1 || hints.indexOf('delete') !== -1) return true;

    return hints.indexOf('wishlist') !== -1 && hints.indexOf('add') === -1;
  }

  function decorateRemoveButton(control) {
    control.setAttribute('data-nobo-wishlist-remove-decorated', 'true');
    control.classList.add('nobo-wishlist-remove-heart');

    if (!control.getAttribute('aria-label') || getControlText(control) === 'x' || getControlText(control) === '×') {
      control.setAttribute('aria-label', 'Remove from wishlist');
    }

    while (control.firstChild) {
      control.removeChild(control.firstChild);
    }

    if (heartIconUrl) {
      var icon = document.createElement('img');
      icon.className = 'nobo-wishlist-remove-heart__icon';
      icon.src = heartIconUrl;
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      control.appendChild(icon);
    }
  }

  function syncWishlistRemoveButtons() {
    var root = getWishlistRoot();
    if (!root) return;

    Array.prototype.forEach.call(root.querySelectorAll(removeButtonSelector), function (control) {
      if (isWishlistRemoveControl(control)) {
        decorateRemoveButton(control);
      }
    });
  }

  function getCardFromCartElement(element, root) {
    var card = element.closest(cardSelector);
    var parent = element.parentElement;
    var depth = 0;
    var candidate = null;

    if (card && card.querySelector('img')) return card;

    while (parent && parent !== root && !parent.matches(cardBoundarySelector) && depth < 10) {
      if (parent.querySelector('img') && parent.contains(element)) {
        candidate = parent;
      }

      parent = parent.parentElement;
      depth += 1;
    }

    return candidate;
  }

  function getElementRectRelativeToParent(element, parent) {
    var elementRect = element.getBoundingClientRect();
    var parentRect = parent.getBoundingClientRect();

    return {
      top: elementRect.top - parentRect.top + parent.scrollTop,
      left: elementRect.left - parentRect.left + parent.scrollLeft,
      width: elementRect.width,
      height: elementRect.height
    };
  }

  function getMediaHostFromCard(card) {
    var image = card.querySelector('img');
    var host;

    if (!image) return null;

    host = image.closest(mediaHostSelector);

    while (host && host !== card && (host.tagName === 'A' || host.tagName === 'PICTURE' || host.tagName === 'IMG')) {
      host = host.parentElement;
    }

    if (!host || host === card) {
      host = image.parentElement;

      while (host && host !== card && (host.tagName === 'A' || host.tagName === 'PICTURE' || host.tagName === 'IMG')) {
        host = host.parentElement;
      }
    }

    return host && host !== card ? host : null;
  }

  function isAddToCartControl(control) {
    var text = getControlText(control);
    var hints = getControlHints(control);
    var submitControl = control.matches('button[type="submit"], input[type="submit"], [type="submit"]');
    var form = control.matches('form') ? control : control.closest('form');
    var action = form ? form.getAttribute('action') || '' : '';

    if (control.closest(headingSelector)) return false;
    if (control.getAttribute('data-nobo-wishlist-remove-decorated') === 'true') return false;
    if (text === 'x' || text === '×') return false;
    if (hints.indexOf('remove') !== -1 || hints.indexOf('delete') !== -1) return false;
    if (
      text.indexOf('add to cart') !== -1 &&
      Array.prototype.some.call(control.children, function (child) {
        return getControlText(child).indexOf('add to cart') !== -1;
      })
    ) {
      return false;
    }

    return (
      action.indexOf('/cart/add') !== -1 ||
      text.indexOf('add to cart') !== -1 ||
      text.indexOf('añadir al carrito') !== -1 ||
      text.indexOf('agregar al carrito') !== -1 ||
      (submitControl && hints.indexOf('cart') !== -1) ||
      (submitControl && hints.indexOf('add') !== -1)
    );
  }

  function getCartElement(control) {
    var form = control.matches('form') ? control : control.closest('form, .wk-form');
    var interactive = control.matches('button, a, [role="button"], input[type="submit"], [type="submit"]')
      ? control
      : control.closest('button, a, [role="button"], input[type="submit"], [type="submit"]');

    return form || interactive || control;
  }

  function positionCartControl(control, root) {
    var cartElement = getCartElement(control);
    var card = getCardFromCartElement(cartElement, root);
    var mediaHost = card && getMediaHostFromCard(card);
    var image = card && card.querySelector('img');
    var imageRect;

    if (!card || !image) return;

    card.classList.add('nobo-wishlist-card');
    cartElement.classList.add('nobo-wishlist-cart-form');
    cartElement.setAttribute('data-nobo-wishlist-cart-positioned', 'true');

    if (mediaHost) {
      mediaHost.classList.add('nobo-wishlist-media-host');

      cartElement.style.removeProperty('inset-block-start');
      cartElement.style.removeProperty('inset-block-end');
      cartElement.style.removeProperty('inset-inline-end');

      if (!mediaHost.contains(cartElement)) {
        mediaHost.appendChild(cartElement);
      }

      return;
    }

    imageRect = getElementRectRelativeToParent(image, card);
    cartElement.style.setProperty('inset-block-start', imageRect.top + imageRect.height - 53 + 'px');
    cartElement.style.setProperty('inset-block-end', 'auto');
    cartElement.style.setProperty('inset-inline-end', card.offsetWidth - imageRect.left - imageRect.width + 16 + 'px');

    if (!card.contains(cartElement) || cartElement.parentElement !== card) {
      card.appendChild(cartElement);
    }
  }

  function positionDetectedCartControls(root) {
    Array.prototype.forEach.call(root.querySelectorAll(cartControlSelector), function (control) {
      if (isVisible(control) && isAddToCartControl(control)) {
        positionCartControl(control, root);
      }
    });
  }

  function positionKnownWishlistForms(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.wk-form, form[action*="/cart/add"]'), function (form) {
      if (isVisible(form) && form.querySelector('button, input[type="submit"], [type="submit"]')) {
        positionCartControl(form, root);
      }
    });
  }

  function clearDetachedCartClasses(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.nobo-wishlist-cart-form'), function (cartElement) {
      if (!cartElement.closest(cardSelector)) {
        cartElement.classList.remove('nobo-wishlist-cart-form');
        cartElement.removeAttribute('data-nobo-wishlist-cart-positioned');
      }
    });
  }

  function syncWishlistCartForms() {
    var root = getWishlistRoot();
    if (!root) return;

    clearDetachedCartClasses(root);
    positionKnownWishlistForms(root);
    positionDetectedCartControls(root);
  }

  function syncWishlist() {
    syncWishlistHeading();
    syncWishlistRemoveButtons();
    syncWishlistCartForms();
  }

  function scheduleWishlistSync() {
    if (syncScheduled) return;

    syncScheduled = true;
    window.requestAnimationFrame(function () {
      syncScheduled = false;
      syncWishlist();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleWishlistSync);
  window.addEventListener('load', scheduleWishlistSync);
  window.addEventListener('resize', scheduleWishlistSync);

  var observer = new MutationObserver(scheduleWishlistSync);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
